import { Component, inject, input, output, signal } from '@angular/core';
import { Router } from '@angular/router';
import { WHSafeTranslateService } from '@workheld/workheld-shared-lib';
import { dynamicAnimation } from '../../helpers/animations';

export interface WHChipMenuItem {
  translateKey: string;
  actionKey: string;
  disableByObjectKey?: string;
  disableById?: string;
}

@Component({
  selector: 'app-w-h-chip-list',
  templateUrl: './w-h-chip-list.component.html',
  styleUrls: ['./w-h-chip-list.component.scss'],
  standalone: false,
  animations: [dynamicAnimation],
})
export class WHChipListComponent {
  private readonly router = inject(Router);
  private readonly safeTranslateService = inject(WHSafeTranslateService);

  data = input([], {
    transform: (value: any) => {
      if (!value || !Array.isArray(value)) return [];
      for (const item of value) {
        for (const key of Object.keys(item)) {
          if (typeof item[key] === 'string') {
            item[key] = this.safeTranslateService.instant(item[key]);
          }
        }
      }
      return value;
    },
  });

  navigateToKey = input('');
  imageKey = input();
  // Key of an inline (data URI) image; when present it is used instead of fetching imageKey
  imageDataUriKey = input('');
  placeholderImg = input();
  titleKey = input('');
  badgeKey = input('');
  isDisabled = input(false);
  maxHeight = input('100%');
  isRemoveButtonVisible = input(false);
  // Give a translation key and the actionkey should be implemented in the parent component
  menuItems = input([] as WHChipMenuItem[]);
  tooltipKeys = input([] as string[]);
  icon = input('');
  matIcon = input('');
  isStacked = input(true);
  isLoading = input(false);
  showScrollBackground = input(false);
  removingChip = signal(null);
  suffixIcon = input(null);

  // Emit the item to be removed
  handleRemoveChip = output<any>();
  // The call back from triggering the menu item from input menuItems
  handleMenuTrigger = output<any>();

  getTooltip(item: any) {
    let tooltip = item?.gradient
      ? this.safeTranslateService.instant(
          'workobject.model.responsibletechnician',
        ) + ': '
      : '';

    if (!this.tooltipKeys()?.length) return '';
    this.tooltipKeys().forEach((key) => {
      if (key?.length && key in item) {
        tooltip += `${item[key]} `;
      }
    });

    return tooltip;
  }

  getBadge(item: any) {
    return this.badgeKey() ? item[this.badgeKey()] : null;
  }

  handleNavigate(item: any) {
    const key = this.navigateToKey();

    if (!key) {
      return;
    }

    const commands = item?.[key];

    if (Array.isArray(commands) && commands.length > 0) {
      this.router.navigate(commands);
      return;
    }

    if (typeof commands === 'string' && commands.length > 0) {
      this.router.navigateByUrl(commands);
    }
  }

  onRemoveChip(event, item) {
    event.stopPropagation();
    this.removingChip.set(item);
    this.handleRemoveChip.emit(item);
  }

  onMenuItemClick(payload, actionKey) {
    // This should be implemented in the parent component
    // Switch case on actionKey
    this.handleMenuTrigger.emit({ actionKey, payload });
  }
}
